export const LoadingDots = ({ customClassName = '', id = '' }: { customClassName?: string; id?: string }) => {
  return (
    <svg
      id={`${id}-loading-dots`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid meet"
      width="150"
      height="50"
      viewBox="0 0 450 200"
      className={customClassName}
    >
      <defs>
        <animateTransform
          repeatCount="indefinite"
          dur="39s"
          begin="0s"
          xlinkHref={`#_R_G_L_3_G_${id}`}
          fill="freeze"
          attributeName="transform"
          from="1 1"
          to="1 1"
          type="scale"
          additive="sum"
          keyTimes="0;0.0128205;0.025641;0.1538462;0.1666667;0.1794872;0.2948718;0.3076923;0.3205128;0.4358974;0.4487179;0.4615385;0.5769231;0.5897436;0.6025641;0.7307692;0.7435897;0.7564103;0.8717949;0.8846154;0.8974359;1"
          values="1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1"
          keySplines="0.167 0.167 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.833 1;0.167 0.167 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="39s"
          begin="0s"
          xlinkHref={`#_R_G_L_3_G_${id}`}
          fill="freeze"
          attributeName="transform"
          from="349.974 -32.501"
          to="349.974 -32.501"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="349.974 -32.501;349.974 -32.501"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="39s"
          begin="0s"
          xlinkHref={`#_R_G_L_2_G_${id}`}
          fill="freeze"
          attributeName="transform"
          from="1 1"
          to="1 1"
          type="scale"
          additive="sum"
          keyTimes="0;0.025641;0.0384615;0.0512821;0.1794872;0.1923077;0.2051282;0.3205128;0.3333333;0.3461538;0.4615385;0.474359;0.4871795;0.6025641;0.6153846;0.6282051;0.7564103;0.7692308;0.7820513;0.8974359;0.9102564;0.9230769;1"
          values="1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1"
          keySplines="0.167 0.167 0.667 1;0.167 0.167 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.833 1;0.167 0.167 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="39s"
          begin="0s"
          xlinkHref={`#_R_G_L_2_G_${id}`}
          fill="freeze"
          attributeName="transform"
          from="349.974 -32.501"
          to="349.974 -32.501"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="349.974 -32.501;349.974 -32.501"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="39s"
          begin="0s"
          xlinkHref={`#_R_G_L_1_G_${id}`}
          fill="freeze"
          attributeName="transform"
          from="1 1"
          to="1 1"
          type="scale"
          additive="sum"
          keyTimes="0;0.0512821;0.0641026;0.0769231;0.2051282;0.2179487;0.2307692;0.3461538;0.3589744;0.3717949;0.4871795;0.5;0.5128205;0.6282051;0.6410256;0.6538462;0.7820513;0.7948718;0.8076923;0.9230769;0.9358974;0.9487179;1"
          values="1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1"
          keySplines="0.167 0.167 0.667 1;0.167 0.167 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.833 1;0.167 0.167 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="39s"
          begin="0s"
          xlinkHref={`#_R_G_L_1_G_${id}`}
          fill="freeze"
          attributeName="transform"
          from="349.974 -32.501"
          to="349.974 -32.501"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="349.974 -32.501;349.974 -32.501"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="39s"
          begin="0s"
          xlinkHref={`#_R_G_L_0_G_${id}`}
          fill="freeze"
          attributeName="transform"
          from="1 1"
          to="1 1"
          type="scale"
          additive="sum"
          keyTimes="0;0.0769231;0.0897436;0.1025641;0.2307692;0.2435897;0.2564103;0.3717949;0.3846154;0.3974359;0.5128205;0.525641;0.5384615;0.6538462;0.6666667;0.6794872;0.8076923;0.8205128;0.8333333;0.9487179;0.9615385;0.974359;1"
          values="1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1;1.2 1.2;1 1;1 1"
          keySplines="0.167 0.167 0.667 1;0.167 0.167 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.833 1;0.167 0.167 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="39s"
          begin="0s"
          xlinkHref={`#_R_G_L_0_G_${id}`}
          fill="freeze"
          attributeName="transform"
          from="349.974 -32.501"
          to="349.974 -32.501"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="349.974 -32.501;349.974 -32.501"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate attributeType="XML" attributeName="opacity" dur="39s" from="0" to="1" xlinkHref={`#time_group_${id}`} />
      </defs>
      <g id={`_R_G_${id}`}>
        <g id={`_R_G_L_3_G_${id}`} transform=" translate(52.522, 100.255)">
          <path
            id={`_R_G_L_3_G_D_0_P_0_${id}`}
            fill="currentColor"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M-349.97 -3.75 C-369.99,-3.75 -386.22,12.48 -386.22,32.5 C-386.22,52.52 -369.99,68.75 -349.97,68.75 C-329.96,68.75 -313.73,52.52 -313.73,32.5 C-313.73,12.48 -329.96,-3.75 -349.97,-3.75z "
          />
        </g>
        <g id={`_R_G_L_2_G_${id}`} transform=" translate(167.188, 100.255)">
          <path
            id={`_R_G_L_2_G_D_0_P_0_${id}`}
            fill="currentColor"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M-349.97 -3.75 C-369.99,-3.75 -386.22,12.48 -386.22,32.5 C-386.22,52.52 -369.99,68.75 -349.97,68.75 C-329.96,68.75 -313.73,52.52 -313.73,32.5 C-313.73,12.48 -329.96,-3.75 -349.97,-3.75z "
          />
        </g>
        <g id={`_R_G_L_1_G_${id}`} transform=" translate(281.855, 100.255)">
          <path
            id={`_R_G_L_1_G_D_0_P_0_${id}`}
            fill="currentColor"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M-349.97 -3.75 C-369.99,-3.75 -386.22,12.48 -386.22,32.5 C-386.22,52.52 -369.99,68.75 -349.97,68.75 C-329.96,68.75 -313.73,52.52 -313.73,32.5 C-313.73,12.48 -329.96,-3.75 -349.97,-3.75z "
          />
        </g>
        <g id={`_R_G_L_0_G_${id}`} transform=" translate(396.522, 100.255)">
          <path
            id={`_R_G_L_0_G_D_0_P_0_${id}`}
            fill="currentColor"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M-349.97 -3.75 C-369.99,-3.75 -386.22,12.48 -386.22,32.5 C-386.22,52.52 -369.99,68.75 -349.97,68.75 C-329.96,68.75 -313.73,52.52 -313.73,32.5 C-313.73,12.48 -329.96,-3.75 -349.97,-3.75z "
          />
        </g>
      </g>
      <g id={`${id}time_group`} />
    </svg>
  )
}
